import Typography from 'components/shared/generic/typography/presentational/Typography';
import ModalOuterContainer from '../containers/ModalOuterContainer';
import ButtonContainer from 'components/shared/generic/buttonContainer/presentational/ButtonContainer';
import Button from 'components/shared/generic/button/presentational/Button';

interface InfoModalProps {
    title: string;
    descriptionText?: string;
    confirmText?: string;
    linkText?: string;
    linkHref?: string;
    hideModal: () => void;
}

const InfoModal = ({
    title,
    descriptionText,
    confirmText,
    linkText,
    linkHref,
    hideModal,
}: InfoModalProps) => (
    <ModalOuterContainer customButtons className="status-modal">
        <div className="description">
            <Typography tag="h1">{title}</Typography>
            <Typography className="generic-text intro-text">
                {descriptionText}{' '}
                {linkText && linkHref && (
                    <a className="info-modal-link" href={linkHref}>
                        {linkText}
                    </a>
                )}
            </Typography>
        </div>
        <ButtonContainer className="center">
            <Button onClick={hideModal}>{confirmText}</Button>
        </ButtonContainer>
    </ModalOuterContainer>
);

export default InfoModal;
